export default {
	filterName({ sequence }) {
		if (sequence.filter) {
			return sequence.filter.name;
		}

		return '';
	}
};
